import { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import Loading from "../../../components/Loading";
import { useClaims } from "../../../auth/ClaimsProvider";
import { useOrgUnitIdCurrent } from "../../../auth/useOrgUnitIdCurrent";

interface StorefrontRouteGuardProps {
  children: ReactNode;
}

export default function StorefrontRouteGuard({
  children,
}: StorefrontRouteGuardProps) {
  const { claimsLoading } = useClaims();
  const orgUnitId = useOrgUnitIdCurrent();
  const { prefix } = useParams();

  if (claimsLoading) {
    return <Loading />;
  }

  if (orgUnitId === null) {
    return <Navigate to={`${prefix ? `/${prefix}` : ""}/home`} replace />;
  }

  return <>{children}</>;
}
